import { messages } from '@/i18n/messages'

const STORAGE_KEY = 'smartfix-locale'

function readStoredLang() {
  try {
    const v = localStorage.getItem(STORAGE_KEY)
    if (v === 'th' || v === 'en') return v
  } catch (e) { /* ignore */ }
  return 'en'
}

export default {
  namespaced: true,
  state: {
    lang: readStoredLang(),
  },
  mutations: {
    SET_LANG(state, lang) {
      if (lang !== 'th' && lang !== 'en') return
      state.lang = lang
      try {
        localStorage.setItem(STORAGE_KEY, lang)
      } catch (e) { /* ignore */ }
      if (typeof document !== 'undefined') {
        document.documentElement.lang = lang === 'en' ? 'en' : 'th'
      }
    },
  },
  actions: {
    setLang({ commit }, lang) {
      commit('SET_LANG', lang)
    },
  },
  getters: {
    lang: (s) => s.lang,
    messages: (s) => messages[s.lang] || messages.th,
    t: (state) => {
      void state.lang
      return (key) => {
        const dict = messages[state.lang] || messages.en
        if (dict[key] !== undefined) return dict[key]
        const other = state.lang === 'en' ? messages.th : messages.en
        if (other[key] !== undefined) return other[key]
        return key
      }
    },
  },
}
